module.exports = __webpack_public_path__ + "static/san-diego-e45917fa5e463c7abe2a781a2d5872dd.png";